import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import { CollectionProvider } from '../main/collection/actions/reducer';

import SessionRoutes from '../main/session/routes';
import { SessionProvider } from '../main/session/provider';

import Index from '../main/collection/index';
import Login from '../main/session/routes';

import '../stylesheet/main.css';

class App extends React.Component{
  render() {
    return (
      <SessionProvider>
        <CollectionProvider>
          <BrowserRouter>
            <React.Fragment>
              <Switch>
                <Route path="/login" component={Login} exact />
                <Route path="/login/**" component={Login} exact />
                <Route path="/p/new" component={Index} exact />
                <Route path="/p/:postid" component={Index} exact />
                <Route path="/t/:tag" component={Index} exact />
                <Route path="/**/p/:postid" component={Index} exact />
                <Route path="/**/t/:tag" component={Index} exact />
                <Route path="/**/" component={Index} />
                <Route path="/" component={Index} exact />
              </Switch>
            </React.Fragment>
          </BrowserRouter>
        </CollectionProvider>
      </SessionProvider>
    );
  }
}

export default App;